export const loginUser = (user) => {
	try {
		localStorage.setItem("user", JSON.stringify(user));
	} catch (err) {}
};
export const logout = () => {
	try {
		localStorage.removeItem("user");
	} catch (err) {}
};
export const getUser = () => {
	try {
		const user = JSON.parse(localStorage.getItem("user"));

		if (user === null) {
			return undefined;
		}
		return user;
	} catch (err) {
		return null;
	}
};

// cart storage
export const getCart_ = () => {
	try {
		const cart = JSON.parse(localStorage.getItem("cart"));

		if (cart === null) {
			return undefined;
		}
		return cart;
	} catch (err) {
		return null;
	}
};
export const setCart_ = (cart) => {
	try {
		localStorage.setItem("cart", JSON.stringify(cart));
	} catch (err) {}
};

export const emptyCart_ = () => {
	try {
		localStorage.removeItem("cart");
	} catch (err) {}
};

// subscription
export const getSubscription_ = () => {
	try {
		const subscription = JSON.parse(localStorage.getItem("subscription"));

		if (subscription === null) {
			return undefined;
		}
		return subscription;
	} catch (err) {
		return null;
	}
};
export const setSubscription_ = (subscription) => {
	try {
		localStorage.setItem("subscription", JSON.stringify(subscription));
	} catch (err) {}
};
export const emptySubscription_ = () => {
	try {
		localStorage.removeItem("subscription");
	} catch (err) {}
};

// compare storage
export const getCompare = () => {
	try {
		const compare = JSON.parse(localStorage.getItem("compare"));

		if (compare === null) {
			return undefined;
		}
		return compare;
	} catch (err) {
		return null;
	}
};
export const setCompare = (compare) => {
	try {
		localStorage.setItem("compare", JSON.stringify(compare));
	} catch (err) {}
};

export const emptyCompare = () => {
	try {
		localStorage.removeItem("compare");
	} catch (err) {}
};

// whish List storage
export const getWishList = () => {
	try {
		const wishlist = JSON.parse(localStorage.getItem("wishlist"));

		if (wishlist === null) {
			return undefined;
		}
		return wishlist;
	} catch (err) {
		return null;
	}
};
export const setWishList = (wishlist) => {
	try {
		localStorage.setItem("wishlist", JSON.stringify(wishlist));
	} catch (err) {}
};

export const emptyWishList = () => {
	try {
		localStorage.removeItem("wishlist");
	} catch (err) {}
};

// save later storage
export const getSaveLater = () => {
	try {
		const saveLater = JSON.parse(localStorage.getItem("save_later"));
		if (saveLater === null) {
			return undefined;
		}
		return saveLater;
	} catch (err) {
		return null;
	}
};
export const setSaveLater = (saveLater) => {
	try {
		localStorage.setItem("save_later", JSON.stringify(saveLater));
	} catch (err) {}
};

export const emptySaveLater = () => {
	try {
		localStorage.removeItem("save_later");
	} catch (err) {}
};

export const getSessionIdStorage = async () => {
	try {
		const sessionId = localStorage.getItem("chatSessionId");
		return sessionId;
	} catch (err) {
		return null;
	}
};
export const setSessionIdStorage = (sessionId) => {
	try {
		localStorage.setItem("chatSessionId", sessionId);
	} catch (err) {}
};
export const removeSessionIdStorage = async () => {
	try {
		localStorage.removeItem("chatSessionId");
	} catch (err) {}
};

export const getSettings = () => {
	try {
		const settings = JSON.parse(localStorage.getItem("settings"));

		if (settings === null) {
			return undefined;
		}
		return settings;
	} catch (err) {
		return null;
	}
};

export const getCommonLoginToken = async () => {
	const commonLoginToken = await JSON.parse(
		localStorage.getItem("commonLoginToken")
	);
	return commonLoginToken;
};
export const setCommonLoginToken = (commonLoginToken) => {
	localStorage.setItem("commonLoginToken", JSON.stringify(commonLoginToken));
};
export const removeCommonLoginToken = async () => {
	localStorage.removeItem("commonLoginToken");
};

export const setSettings = (settings) => {
	try {
		localStorage.setItem("settings", JSON.stringify(settings));
	} catch (err) {}
};
